import React from "react";

/**
 * Stain Matching icon — a stack of swatch cards (each divided into 4 boxes)
 * that fan out wide and HOLD while the tile is hovered, then close on leave
 * (see serviceIcons.css). Each card pivots from its bottom. Edit freely; uses
 * currentColor.
 */
const Swatch = ({ cls }) => (
  <g className={`bdrv2-ico-sw ${cls}`}>
    <rect x="20" y="12" width="8" height="26" rx="2" />
    <path d="M20 18.5 H28 M20 25 H28 M20 31.5 H28" />
  </g>
);

const ServiceSwatchIcon = () => (
  <svg
    className="bdrv2-svc-ico bdrv2-ico-swatch"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <g className="bdrv2-ico-swatches">
      <Swatch cls="bdrv2-ico-sw-1" />
      <Swatch cls="bdrv2-ico-sw-2" />
      <Swatch cls="bdrv2-ico-sw-3" />
      <Swatch cls="bdrv2-ico-sw-4" />
    </g>
    {/* rivet that holds the fan deck together (at the pivot point) */}
    <circle cx="24" cy="38" r="1.7" fill="currentColor" stroke="none" />
  </svg>
);

export default ServiceSwatchIcon;
